import { ButtonTab, ButtonTabs } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import styled from "styled-components";
import { EventDetailResource } from "../../shared/types";

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(4)};
`;

const StyledTabs = styled(ButtonTabs)`
	& > div {
		padding: 0;
		height: 40px;
	}

	border-bottom: 1px solid ${({ theme }) => theme.colors.palette.grey[30]};
`;

interface Props {
	event: EventDetailResource;
}

export const EventDetailsContent: FC<Props> = ({ event }) => {
	const { t } = useTranslation();
	return (
		<ContentContainer>
			<StyledTabs color="content">
				<ButtonTab to="../details">{t("Details")}</ButtonTab>
				<ButtonTab to="../users">{t("Users")}</ButtonTab>
				{event.eventType.showFeedbackEvaluation && event.hasFeedbackWithAnswers && (
					<ButtonTab to="../feedback-evaluation">{t("Feedback")}</ButtonTab>
				)}
			</StyledTabs>
			<Outlet />
		</ContentContainer>
	);
};
